import type { Classroom, SeatingChart, Student } from "@classroom/domain";
import { compareStudentNumbers } from "@classroom/domain";

export function rosterClassId(classItem: Classroom | undefined, classes: Classroom[]): string {
  if (!classItem) return "";
  const source = classes.find(
    (item) => item.id === classItem.sharedDataClassId && item.workspaceId === classItem.workspaceId,
  );
  return source && !source.sharedDataClassId ? source.id : classItem.id;
}

export function suggestedSharedClassId(name: string, role: Classroom["classRole"], classes: Classroom[]): string {
  const classCode = name.trim().split(/\s+/)[0]?.toLocaleLowerCase();
  if (!classCode) return "";
  const matches = classes.filter(
    (item) =>
      item.active &&
      !item.sharedDataClassId &&
      item.classRole !== role &&
      item.name.trim().split(/\s+/)[0]?.toLocaleLowerCase() === classCode,
  );
  return matches.length === 1 ? matches[0]!.id : "";
}

export function classStudents(classItem: Classroom | undefined, classes: Classroom[], students: Student[]): Student[] {
  const classId = rosterClassId(classItem, classes);
  return students.filter((student) => student.classId === classId).sort(compareStudentNumbers);
}

export function classSeatingChart(
  classItem: Classroom | undefined,
  classes: Classroom[],
  charts: SeatingChart[],
): SeatingChart | undefined {
  const classId = rosterClassId(classItem, classes);
  return charts.find((chart) => chart.classId === classId);
}

export function setupProgress(
  classItem: Classroom | undefined,
  classes: Classroom[],
  students: Student[],
  charts: SeatingChart[],
) {
  const roster = classStudents(classItem, classes, students).filter((student) => student.active);
  const chart = classSeatingChart(classItem, classes, charts);
  const seated = new Set(Object.values(chart?.seats || {}));
  return {
    hasClass: Boolean(classItem),
    hasRoster: roster.length > 0,
    hasSeating: roster.length > 0 && roster.every((student) => seated.has(student.id)),
    studentCount: roster.length,
  };
}
